import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'

import { AUTH_INPUT } from '@/components/auth-layout'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

export function PasswordInput({
  id,
  placeholder,
  value,
  onChange,
  autoComplete = 'current-password'
}: {
  id: string
  placeholder?: string
  value: string
  onChange: (value: string) => void
  autoComplete?: 'current-password' | 'new-password'
}) {
  const [show, setShow] = useState(false)

  return (
    <div className='relative'>
      <Input
        id={id}
        type={show ? 'text' : 'password'}
        autoComplete={autoComplete}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        className={cn(AUTH_INPUT, 'pr-11 sm:pr-11')}
      />
      <button
        type='button'
        aria-label={show ? 'Hide password' : 'Show password'}
        onClick={() => setShow(!show)}
        className='absolute top-1/2 right-1 flex size-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-lg text-ink-muted transition-colors hover:text-ink'
      >
        {show ? <EyeOff className='size-4' /> : <Eye className='size-4' />}
      </button>
    </div>
  )
}
